import { Input, InputProps } from 'antd'
import { ReactNode, useEffect, useState } from 'react'
import styled from 'styled-components'
import { StyledButtonIcon } from 'styles/styledGlobal'

interface IProps extends InputProps {
  title?: string
  children?: ReactNode
  defaultValue?: string
  search?: (value: string) => void
}

const StyledInput = styled(Input)`
  padding: 1px 1px 1px 8px;
  height: 40px;
  border-radius: 8px;
  max-width: 250px;
  button {
    height: 32px;
    width: 32px;
  }
`

const InputSearch = (props: IProps) => {
  const { search, onChange, ...resProps } = props
  const [value, setValue] = useState('')
  const handleOnChange = (e: any) => {
    setValue(e.target.value)
    if (onChange) onChange(e)
  }

  const handleOnSearch = () => {
    if (search) search(value)
  }
  useEffect(() => {
    if (props?.defaultValue) {
      setValue(props?.defaultValue)
    }
  }, [])
  return (
    <>
      <StyledInput
        id="search"
        placeholder="Tìm kiếm"
        value={value}
        defaultValue={props?.defaultValue}
        onPressEnter={handleOnSearch}
        suffix={
          <StyledButtonIcon
            onClick={handleOnSearch}
            type="primary"
            icon={<img src="/images/ic-search-light.svg" alt="" />}
          />
        }
        onChange={handleOnChange}
        {...resProps}
      />
    </>
  )
}

export default InputSearch
